import { Box, Divider, Stack, TextField, Typography } from '@mui/material';

import { formatInstallments } from '../../utils/puntajeFormatters';

const PreAdjudicationConfirmationContent = ({
  suggestion,
  preAdjudicationDate,
  onPreAdjudicationDateChange,
  observations,
  onObservationsChange,
}) => (
  <Stack spacing={2}>
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Tipo sugerido
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {suggestion?.suggestion_type || '-'}
      </Typography>
    </Box>

    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Contrato
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {suggestion?.contract_number || '-'}
      </Typography>
    </Box>

    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Cuotas a impactar
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Requeridas: {formatInstallments(suggestion?.required_installments)} | Disponibles:{' '}
        {formatInstallments(suggestion?.available_installments)}
      </Typography>
    </Box>

    <Divider />

    <TextField
      fullWidth
      required
      type="date"
      label="Fecha de preadjudicación"
      value={preAdjudicationDate}
      onChange={onPreAdjudicationDateChange}
      InputLabelProps={{ shrink: true }}
    />

    <TextField
      fullWidth
      multiline
      minRows={3}
      label="Observaciones"
      value={observations}
      onChange={onObservationsChange}
    />
  </Stack>
);

export default PreAdjudicationConfirmationContent;
